function getLensProductVariantName(lensProduct) {
  if (!lensProduct?.variants?.length) {
    return;
  }
  const selected = lensProduct.variants?.find((v) => v.sku === lensProduct.sku);
  const title = selected?.title;
  return title || void 0;
}
export {
  getLensProductVariantName
};
//# sourceMappingURL=get-lens-product-variant-name.js.map
